module.exports = __webpack_public_path__ + "static/media/invoice white.0f7852f1.svg";